import API from '../../../utils/api';

export type PopupFormPayload = {
  title: string;
  body: string;
  imageUrl?: string | null;
  linkUrl?: string | null;
  linkLabel?: string | null;
  isActive: boolean;
  showFrom?: string | null;
  showUntil?: string | null;
  displayOrder?: number;
};

export type PopupItem = {
  popupId: number;
  title: string | null;
  body: string | null;
  imageUrl: string | null;
  linkUrl: string | null;
  linkLabel: string | null;
  isActive: number | boolean;
  showFrom: string | null;
  showUntil: string | null;
  displayOrder: number;
  createdAt?: string;
  updatedAt?: string;
};

export async function fetchPopupDetail(token: string, popupId: number): Promise<PopupItem | null> {
  const response = await API.get(`/admin/popup/${popupId}`, token, {});
  return response?.result?.result ?? null;
}

export async function createPopup(token: string, payload: PopupFormPayload) {
  return API.post('/admin/popup', token, payload);
}

export async function updatePopup(token: string, popupId: number, payload: PopupFormPayload) {
  return API.put(`/admin/popup/${popupId}`, token, payload);
}

export async function deletePopup(token: string, popupId: number) {
  return API.delete(`/admin/popup/${popupId}`, token, {});
}
